import Component from '~/components/component';
import Swiper, { EffectFade, Autoplay } from 'swiper';

export default class Hero extends Component {
	constructor(...args) {
		super(...args);
		this._initDom();
		this.swiper = null;
	}

	_initDom() {
		this.dom.swiperContainer = this._find('.js-swiper');
		this.dom.slideTitle =
			this.dom.component.querySelectorAll('.js-slide-title');
	}

	init() {
		super.init();
		this._initSwiper();
	}

	_initSwiper() {
		if (this.dom.swiperContainer) {
			this.swiper = new Swiper(this.dom.swiperContainer, {
				modules: [Autoplay, EffectFade],
				speed: 700,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				slidesPerView: 1,
				loop: true,
			});
		}
	}
}
